/* eslint-disable import/no-cycle */
import {get} from 'lodash';
import {action, decorate, observable} from 'mobx';
import i18n from '../i18n/i18n';
import {Api} from '../middleware/api';
import {Component} from '../models/component';
import {EntityStore} from './entityStore';

export class ComponentStore extends EntityStore {
  components = [];

  constructor(rootStore) {
    super(rootStore, 'components', Api.components, Component);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.materialStore,
        modelId: 'materialId',
      },
      {
        store: this.rootStore.unitOfMeasurementStore,
        modelId: 'unitOfMeasureId',
      },
    ];
  }

  filterBy({operationId, position}) {
    let result = this.components;
    if (operationId) {
      result = result.filter((component) => get(component, 'operationId') === operationId);
    }
    if (position !== undefined) {
      result = result.filter((component) => component.position === position);
    }

    return result;
  }

  positionFinished(preparation, position) {
    const positionComponents = this.filterBy({operationId: preparation.operationId, position});
    return positionComponents.every((component) =>
      this.rootStore.consumptionStore.actualConsumed(preparation.id, component.id) >= component.toleranceLow);
  }

  // eslint-disable-next-line class-methods-use-this
  positionName(position) {
    return position === null
      ? i18n.t('batchHandling.preparation.otherPosition')
      : `${i18n.t('batchHandling.preparation.position')} ${position}`;
  }

  loadByOperation(operationId) {
    return this.loadAllWithDependencies({params: {operationId}});
  }
}

decorate(ComponentStore, {
  components: observable,
  loadByOperation: action,
});
